module.exports = __webpack_public_path__ + "static/media/left-arrow.e45eb6ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/left-arrow.svg
// module id = 748
// module chunks = 0